import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layers } from 'lucide-react';
import { Button } from '../ui/button';
import NavNewBadge from './NavNewBadge';
import { useResponsive } from '../../context/ResponsiveContext';
import { shouldShowMySkillsHeaderDiscovery, MY_SKILLS_PATH } from '../../utils/featureDiscovery';

/**
 * Mobile header entry point for My Skills discovery (employees, NEW window only).
 */
export default function MySkillsHeaderDiscovery({ user }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isMobile } = useResponsive();

  if (!isMobile || !shouldShowMySkillsHeaderDiscovery(user, pathname)) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={() => navigate(MY_SKILLS_PATH)}
      className="flex h-11 min-h-[44px] w-11 min-w-[44px] shrink-0 items-center justify-center gap-0 overflow-hidden p-0 min-[480px]:h-11 min-[480px]:w-auto min-[480px]:min-w-0 min-[480px]:justify-start min-[480px]:gap-1 min-[480px]:px-2 border-indigo-200 bg-indigo-50/80 text-indigo-800 hover:bg-indigo-100 dark:border-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-200 dark:hover:bg-indigo-900/50 lg:h-8 lg:w-8 lg:min-h-8 lg:min-w-8"
      aria-label="My Skills, new feature"
    >
      <Layers className="h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-400" aria-hidden="true" />
      <span className="hidden min-[480px]:inline text-ds-body font-semibold whitespace-nowrap">
        My Skills
      </span>
      <NavNewBadge compact className="hidden min-[480px]:inline-flex" />
    </Button>
  );
}
